<template>
    <div>
        <v-dialog
            transition="dialog-bottom-transition"
            v-model="dialog"
            persistent
            width="900"
        >
            <v-card flat color="grey lighten-3" min-height="300">
                <w-toolbar color="blue darken-2" title="Paie Calculatrice"/>
                <v-card-text>
                   <v-container fluid>
                       <v-row>
                           <v-col cols="12">
                               <v-form ref="form">
                                   <w-text-field
                                       v-model="screenText"
                                       :loading="loading_validation"
                                       :rules="[() => valid || 'Formule n\'est pas valide']"
                                   ></w-text-field>
                               </v-form>
                           </v-col>
                           <v-col cols="12">
                               <v-tabs color="teal">
                                   <v-tab>Rubriques</v-tab>
                                   <v-tab v-for="item in items" :key="`tab-${item.id}`">
                                       {{ item.name }}
                                   </v-tab>
                                   <v-tab-item>
                                       <v-container fluid>
                                           <v-row dense>
                                               <v-col cols="12">
                                                   <v-btn-toggle>
                                                       <v-btn
                                                           color="pink"
                                                           dark
                                                           width="250"
                                                           @click="paySectionDialog = true"
                                                       >
                                                           <strong>Rubriques</strong>
                                                       </v-btn>
                                                       <v-btn
                                                           v-for="(item, index) in numbers" :key="index"
                                                           :color="item.color"
                                                           dark
                                                           @click="addSymbol(item.value)"
                                                       >
                                                           <strong>{{ item.text }}</strong>
                                                       </v-btn>
                                                   </v-btn-toggle>
                                               </v-col>
                                           </v-row>
                                       </v-container>
                                   </v-tab-item>
                                   <v-tab-item v-for="item in items" :key="`tab-item-${item.id}`">
                                       <v-container fluid>
                                           <v-btn-toggle>
                                               <v-btn
                                                   v-for="(item, index) in getItems(item.id)" :key="index"
                                                   :color="getRandomColor()"
                                                   outlined
                                                   @mouseover="description = item.description"
                                                   @mouseout="description = null"
                                                   @click="addSymbol(item.value)"
                                               >
                                                   <strong>{{ item.text }}</strong>
                                               </v-btn>
                                           </v-btn-toggle>
                                       </v-container>
                                   </v-tab-item>
                               </v-tabs>
                           </v-col>
                           <v-container>
                               <v-alert
                                   v-if="description"
                                   border="left"
                                   colored-border
                                   color="deep-purple accent-4"
                                   elevation="2"
                               >
                                   <strong>{{ description }}</strong>
                               </v-alert>
                           </v-container>
                       </v-row>
                   </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn depressed outlined color="teal darken-1" @click="dialog = false">
                        {{ $t('common.cancel') }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                        depressed
                        dark
                        color="teal darken-1"
                        :loading="loading_validation"
                        @click="apply"
                    >
                        {{ $t('common.apply') }}
                        <v-icon right>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-textarea
            :value="value"
            label="Formule *"
            outlined
            dense
            readonly
            hide-details="auto"
            :color="inputColor"
            :background-color="backgroundColor"
            @click="dialog = true"
        ></v-textarea>

        <select-pay-section-component
            single
            :dialog="paySectionDialog"
            :selected="selectedPaySection"
            @save="setPaySection"
            @close="closePaySectionDialog"
        ></select-pay-section-component>

        <input type="hidden"/>
    </div>
</template>

<script>
import axios from "axios";
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    props: ['value'],
    setup(props, {emit}) {
        const {inputColor, backgroundColor} = useSharedData();
        const dialog = ref(false);
        
        const item = ref(null);
        const screenText = ref("");
        const description = ref("");


        const items = [
            {id: "t_s_cnas_irg", name: "Tot. Coti. Impo."},
            {id: "t_s_cnas_irg_reg", name: "Tot. Cotisables Impo. régul."},
            {id: "tests_ok", name: "Variables logiques"},
            {id: "temps", name: "Temps et retenues absences"},
        ];
        const numbers = [
            {value: "P1", text: "P1", description: "", color: "purple"},
            {value: "P2", text: "P2", description: "", color: "purple"},
            {value: "P3", text: "P3", description: "", color: "purple"},
            {
                value: "MODE_IRG",
                text: "MODE_IRG",
                description: "Mode IRG (Normal, Abattement 25% et 50% régions du sud, Exoréné, Personne handicapé",
                color: "brown"
            },
            {value: "Et", text: "Et", description: "", color: "orange"},
            {value: "Ou", text: "Ou", description: "", color: "orange"},
            {value: "Non", text: "Non", description: "", color: "orange"},
            /*{ value: "=", text: "=", description: "", color: "primary" },
            { value: ">", text: ">", description: "", color: "primary" },
            { value: ">=", text: ">=", description: "", color: "primary" },
            { value: "<", text: "<", description: "", color: "primary" },
            { value: "<=", text: "<=", description: "", color: "primary" },
            { value: "#", text: "#", description: "", color: "primary" },
            { value: "(", text: "(", description: "", color: "teal" },
            { value: ")", text: ")", description: "", color: "teal" },
            { value: "7", text: "7", description: "", color: "teal" },
            { value: "8", text: "8", description: "", color: "teal" },
            { value: "9", text: "9", description: "", color: "teal" },
            { value: "*", text: "*", description: "", color: "teal" },
            { value: "4", text: "4", description: "", color: "teal" },
            { value: "5", text: "5", description: "", color: "teal" },
            { value: "6", text: "6", description: "", color: "teal" },
            { value: "-", text: "-", description: "", color: "teal" },
            { value: "1", text: "1", description: "", color: "teal" },
            { value: "2", text: "2", description: "", color: "teal" },
            { value: "3", text: "3", description: "", color: "teal" },
            { value: "+", text: "+", description: "", color: "teal" },
            { value: "-", text: "+/-", description: "", color: "teal" },
            { value: "0", text: "0", description: "", color: "teal" },
            { value: ".", text: ".", description: "", color: "teal" },
            { value: "/", text: "/", description: "", color: "teal" },*/
        ];
        const t_s_cnas_irg = [
            {
                value: "T_S_CNAS",
                text: "T_S_CNAS",
                description: "Total rubriques (Gains/Retenues) Cotisables sécurité sociale",
                color: "primary",
            },
            {
                value: "T_S_IRG",
                text: "T_S_IRG",
                description: "Total rubriques (Gains/Retenues) Imposable à IRG",
                color: "primary",
            },
            {
                value: "T_RET_ABS",
                text: "T_RET_ABS",
                description: "Total retenues absences",
                color: "deep-orange",
            },
            {
                value: "T_GAINS",
                text: "T_GAINS",
                description: "Total rubriques Gains",
                color: "primary",
            },
            {
                value: "T_BRUT",
                text: "T_BRUT",
                description: "Total rubriques compsantes du Brute",
                color: "primary",
            },
            {
                value: "T_RET",
                text: "T_RET",
                description: "Total rubriques Retenues",
                color: "primary",
            },
            {
                value: "T_S_CNAS_IMPOT1",
                text: "T_S_CNAS_IMPOT1",
                description:
                    "Total rubriques à 10%  et Cotisable sécurité sociale en meme temps",
                color: "primary",
            },
            {
                value: "T_S_CNAS_IRG",
                text: "T_S_CNAS_IRG",
                description:
                    "Total rubriques à IRG et Cotisable sécurité sociale en meme temps",
                color: "primary",
            },

            {
                value: "T_S_IMPOT1",
                text: "T_S_IMPOT1",
                description: "Total des rubriques Imposable à 10%",
                color: "primary",
            },
        ];
        const t_s_cnas_irg_reg = [
            {
                value: "T_S_CNAS_IMPOT1_REG_N",
                text: "T_S_CNAS_IMPOT1_REG_N",
                description: "Total rub. Cotisables Sécu. sle. & Imposable 10% & Case Régularisation décochée",
                color: "primary",
            },
            {
                value: "T_S_CNAS_IMPOT1_REG_O",
                text: "T_S_CNAS_IMPOT1_REG_O",
                description:
                    "Total rub. Cotisables Sécu. sle. & Imposable 10% & Case Régularisation cochée",
                color: "primary",
            },
            {
                value: "T_S_CNAS_IRG_REG_N",
                text: "T_S_CNAS_IRG_REG_N",
                description:
                    "Total rub. Cotisables Sécu. sle. & Imposable IRG & Case Régularisation décochée",
                color: "primary",
            },
            {
                value: "T_S_CNAS_IRG_REG_O",
                text: "T_S_CNAS_IRG_REG_O",
                description:
                    "Total rub. Cotisables Sécu. sle. & Imposable IRG & Case Régularisation Cochée",
                color: "primary",
            },
            {
                value: "T_S_CNAS_IRG_REG_O",
                text: "T_S_CNAS_IRG_REG_O",
                description:
                    "Total rub. Cotisables Sécu. sle. & Imposable IRG & Case Régularisation Cochée",
                color: "primary",
            },
            {
                value: "T_GAINS_REG_O",
                text: "T_GAINS_REG_O",
                description: "Total rub. gains & Case Régularisation cochée",
                color: "primary",
            },
            {
                value: "T_RET_REG_O",
                text: "T_RET_REG_O",
                description: "Total rub. retenue & Case Régularisation cochée",
                color: "primary",
            },
            {
                value: "T_S_IMPOT1_REG_N",
                text: "T_S_IMPOT1_REG_N",
                description:
                    "Total rub. Imposable 10% & Case Régularisation décochée",
                color: "primary",
            },
            {
                value: "T_S_IMPOT1_REG_O",
                text: "T_S_IMPOT1_REG_O",
                description: "Total rub. Imposable 10% & Case Régularisation cochée",
                color: "primary",
            },
            {
                value: "T_SIRG_REG_N",
                text: "T_SIRG_REG_N",
                description:
                    "Total rub. Imposable IRG & Case Régularisation décochée",
                color: "primary",
            },
            {
                value: "T_SIRG_REG_O",
                text: "T_SIRG_REG_O",
                description: "Total rub. Imposable IRG & Case Régularisation cochée",
                color: "primary",
            },
            {
                value: "T_S_CNAS_REG_N",
                text: "T_S_CNAS_REG_N",
                description: "Total rub. Cotisables Sécu. sle. & Case Régularisation décochée",
                color: "primary",
            },
            {
                value: "T_S_CNAS_REG_O",
                text: "T_S_CNAS_REG_O",
                description: "Total rub. Cotisables Sécu. sle. & Case Régularisation cochée",
                color: "primary",
            },
        ];
        const tests_ok = [
            {
                value: "OK_INTEMPERIES",
                text: "OK_INTEMPERIES",
                description: "1 Si salarié cotise aux INTEMPERIES 0 sinon",
                color: "cyan",
            },
            {
                value: "OK_CNAS",
                text: "OK_CNAS",
                description: "1 Si salarié cotise à la CNAS 0 sinon",
                color: "cyan",
            },
            {
                value: "OK_ETRANGER",
                text: "OK_ETRANGER",
                description: "1 Si salarié est de nationalité étrangères 0 sinon",
                color: "cyan",
            },
            {
                value: "OK_NUM_MUTUELLE",
                text: "OK_NUM_MUTUELLE",
                description: "1 si le salarié possède un numéro mutuel",
                color: "cyan",
            },
            {
                value: "OK_NON_EXONERE_IRG",
                text: "OK_NON_EXONERE_IRG",
                description: "1 si le salarié n'est pas exonéré IRG",
                color: "cyan",
            },
            {
                value: "OK_CONJ_TRAV",
                text: "OK_CONJ_TRAV",
                description: "1 Si le conjoint travail  0 sinon",
                color: "cyan",
            },
            {
                value: "OK_EN_CONGE",
                text: "OK_EN_CONGE",
                description: "1 Salarié en congé  0 sinon",
                color: "cyan",
            },
            {
                value: "OK_MARIE",
                text: "OK_MARIE",
                description: "1 si le salarié et Marié 0 sinon",
                color: "cyan",
            },
            {
                value: "OK_MASCULIN",
                text: "OK_MASCULIN",
                description: "1 si le salarié est de sexe Masculin OK_MASCULIN=0 si feminin",
                color: "cyan",
            },
        ];
        const temps = [
            {
                value: "N_HR_ABS",
                text: "N_HR_ABS",
                description: "Nombre d' heures d'absences",
                color: "deep-orange",
            },
            {
                value: "N_JR_ABS",
                text: "N_JR_ABS",
                description: "Nombre de jours d'absences",
                color: "deep-orange",
            },
            {
                value: "N_HR_TRAV",
                text: "N_HR_TRAV",
                description: "Nombre de heures travaillés",
                color: "deep-orange",
            },
            {
                value: "N_JR_TRAV",
                text: "N_JR_TRAV",
                description: "Nombre de jours travaillés",
                color: "deep-orange",
            },
            {
                value: "N_JR_CONGE",
                text: "N_JR_CONGE",
                description: "Nombre de jours congés",
                color: "deep-orange",
            },
            {
                value: "N_HR_SUP",
                text: "N_HR_SUP",
                description: "Nombre d' heures supplémenatires",
                color: "deep-orange",
            },
            {
                value: "N_HR_JOUR",
                text: "N_HR_JOUR",
                description: "Nombre heures par jour",
                color: "deep-orange",
            },
            {
                value: "N_JR_OUV",
                text: "N_JR_OUV",
                description: "Nombre de jours ouvrables",
                color: "deep-orange",
            },
            {
                value: "N_HR_OUV",
                text: "N_HR_OUV",
                description: "Nombre d'heures ouvrables",
                color: "deep-orange",
            },
            {
                value: "TAUX_CHARGE_PATRONAL",
                text: "TAUX_CHARGE_PATRONAL",
                description: "Taux Charge Patronal",
                color: "deep-orange",
            },
            {
                value: "TAUX_ABATTEMENT",
                text: "TAUX_ABATTEMENT",
                description: "Taux Abattement",
                color: "deep-orange",
            },
        ];

        function getRandomColor() {
            const predefinedColors = [
                'red',       // Red
                'pink',      // Pink
                'purple',    // Purple
                'indigo',    // Indigo
                'teal',      // Teal
                'orange',    // Orange
                'brown',     // Brown
                'blue-grey'  // Blue Grey
            ];

            const randomIndex = Math.floor(Math.random() * predefinedColors.length);
            return `${predefinedColors[randomIndex]} darken-4`;
        }

        function getItems(id) {
            let array = [];
            switch (id) {
                case "t_s_cnas_irg":
                    array = t_s_cnas_irg;
                    break;
                case "t_s_cnas_irg_reg":
                    array = t_s_cnas_irg_reg;
                    break;
                case "tests_ok":
                    array = tests_ok;
                    break;
                case "temps":
                    array = temps;
                    break;
            }
            return array;
        }

        const valid = ref(true);
        const loading_validation = ref(false);
        
        function apply() {
            loading_validation.value = true;
            axios.put(`/paySections/validateFormula`, screenText.value).then(response => {
                valid.value = response.data;
                if (valid.value) {
                    emit("input", screenText.value);
                    dialog.value = false;
                }
            }).finally(() => {
                loading_validation.value = false;
            });
        }

        function addSymbol(e) {
            screenText.value += e;
        }

        const paySectionDialog = ref(false);
        const selectedPaySection = ref([]);
        
        function setPaySection() {
            if (selectedPaySection.value.length > 0) {
                screenText.value += selectedPaySection.value[0].code;
                paySectionDialog.value = false;
            }
            selectedPaySection.value = [];
        }

        function closePaySectionDialog() {
            paySectionDialog.value = false;
        }

        watch(() => props.value, () => {
            screenText.value = props.value;
        }, {immediate: true});

        return {
            dialog,
            inputColor,
            backgroundColor,
            item,
            screenText,
            description,
            paySectionDialog,
            selectedPaySection,
            valid,
            loading_validation,
            items,
            numbers,
            t_s_cnas_irg,
            t_s_cnas_irg_reg,
            tests_ok,
            temps,
            getRandomColor,
            getItems,
            apply,
            addSymbol,
            setPaySection,
            closePaySectionDialog,
        }
    }
};
</script>